export default __webpack_public_path__ + "static/media/sp_1.d3c62e0e.jpg";